import { baseStoreCreator,OptionKey } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';

export interface ScheduledContributionRecordsFiltersState {
  currentAccounts: OptionKey[];
  searchString: string;
}

export const DEFAULT_VALUES: ScheduledContributionRecordsFiltersState = {
  currentAccounts: [ALL_OPTION.value],
  searchString: '',
};

export const useScheduledContributionRecordsFiltersStore = baseStoreCreator<ScheduledContributionRecordsFiltersState>(DEFAULT_VALUES);

export default useScheduledContributionRecordsFiltersStore;